import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./static/js/flexible.js";
import "./static/icon/iconfont.css"
import "./assets/css/quill.bubble.css";
import "./assets/css/quill.core.css";
import "./assets/css/quill.snow.css";
// 全局引入
import 'mv-full-page/lib-dist/mv-full-page.css'
import MvFullPage from 'mv-full-page'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Pagination from "@/components/Pagination";

import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'


Vue.component('Pagination', Pagination)

Vue.use(ElementUI);

Vue.use(MvFullPage)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
